import HistoricalSettlementDetailInquiry from './hisrotical-settlement-detail-inquiry.vue'
export default HistoricalSettlementDetailInquiry
